<template>
  <div>
    <!-- :before-close="handleClose" -->
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="80%"
      :wrapperClosable="false"
    >
      <div class="form-center" v-loading="loading">
        <el-tabs v-model="activeName" type="card" @tab-click="tabClick">
          <el-tab-pane label="备件信息" name="1">
            <el-table
              :data="tableData"
              ref="dialogTable"
              style="width: 100%"
              height="calc(100% - 40px)"
            >
              <el-table-column label="序号" width="50" type="index">
              </el-table-column>

              <el-table-column
                label="备件编号"
                align="center"
                prop="Code"
                sortable
              >
              </el-table-column>
              <el-table-column
                label="备件名称"
                align="center"
                prop="Name"
                sortable
              >
              </el-table-column>
              <el-table-column
                label="备件类型"
                align="center"
                prop="MaterialTypeName"
                sortable
              >
              </el-table-column>
              <el-table-column
                label="备件规格"
                align="center"
                prop="Spec"
                sortable
              >
              </el-table-column>
              <el-table-column
                label="单位"
                align="center"
                prop="storageName"
                sortable
              >
              </el-table-column>
              <el-table-column
                label="库存数量"
                align="right"
                prop="Nums_N"
                sortable
              >
              </el-table-column>
              <el-table-column
                label="货位"
                align="center"
                prop="LocalName"
                sortable
              >
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="备件消耗" name="2">
            <div class="div-top">
              <el-date-picker
                style="width: 300px; margin-left: 10px"
                v-model="searchData.OutTime"
                format="yyyyMM"
                value-format="yyyyMM"
                type="monthrange"
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
              >
              </el-date-picker>

              <el-button
                type="primary"
                @click="handleSearch"
                style="margin-left: 10px"
                >查询</el-button
              >
            </div>
            <el-table
              :data="DataList"
              ref="dialogTable"
              style="width: 100%"
              height="calc(100% - 70px)"
            >
              <el-table-column label="序号" width="50" type="index">
              </el-table-column>

              <el-table-column
                label="出库单号"
                align="center"
                prop="Code"
                sortable
              >
              </el-table-column>
              <el-table-column
                label="出库日期"
                align="center"
                prop="OutTime"
                sortable
              >
                <template slot-scope="scope">
                  {{
                    scope.row.OutTime
                      ? moment(scope.row.OutTime).format('YYYY-MM-DD')
                      : ''
                  }}
                </template>
              </el-table-column>
              <el-table-column
                label="货位"
                align="center"
                prop="LocalName"
                sortable
              >
              </el-table-column>
              <el-table-column
                label="出库类型"
                align="center"
                prop="OutTypeName"
                sortable
              >
              </el-table-column>
              <el-table-column
                label="备件编号"
                align="center"
                prop="MaterialCode"
                sortable
              >
              </el-table-column>
              <el-table-column
                label="备件名称"
                align="center"
                prop="MaterialName"
                sortable
              >
              </el-table-column>
              <el-table-column
                label="备件规格"
                align="center"
                prop="MaterialSpec"
                sortable
              >
              </el-table-column>
              <el-table-column
                label="计量单位"
                align="center"
                prop="storageName"
                sortable
              >
              </el-table-column>
              <el-table-column
                label="出库数量"
                align="center"
                prop="OutNum"
                sortable
              >
              </el-table-column>
              <el-table-column
                label="工单编号"
                align="center"
                prop="WorkOrderCode"
                sortable
              >
              </el-table-column>
              <el-table-column
                label="工单类型"
                align="center"
                prop="WorkOrderTypeName"
                sortable
              >
              </el-table-column>
            </el-table>
            <div
              style="
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: right;
              "
            >
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pagination.PageIndex"
                :page-sizes="pagination.PageSizes"
                :page-size="pagination.PageRows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pagination.total"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="footer" v-loading="loading">
        <el-button @click="close">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  data() {
    return {
      moment,
      activeName: '1',
      title: '',
      loading: false,

      RoleList: [],
      tableData: [],

      drawer: false,
      disabled: false,
      row: {},
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      searchData: {
        OutTime: [],
      },
      DataList: [],
    }
  },
  props: {},
  components: {},
  methods: {
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    tabClick() {
      if (this.activeName === '2') {
        this.getDataList()
      } else {
        this.getInfo(this.row.DeviceId)
      }
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    openForm(title, row = {}, disabled = false) {
      this.drawer = true
      this.disabled = disabled
      this.row = row
      this.activeName = '1'
      this.getInfo(row.DeviceId)
      this.tableData = []
      this.DataList = []
      this.pagination.PageIndex = 1
      this.pagination.PageRows = 20
      this.pagination.total = 0
      this.searchData.OutTime = []
      this.title = title
    },
    getInfo(id) {
      this.loading = true
      this.$http
        .post('/PB/PB_Project/GetDeviceAccessoryDataList?DeviceId=' + id, {})
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.tableData = resJson.Data
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    getDataList() {
      this.loading = true
      this.$http
        .post('TD/TD_OutStorDetail/GetOutStorDetailExpendDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,

          Search: [
            {
              Condition: 'DeviceItemId',
              Keyword: this.row.Id,
            },
            {
              Condition: 'OutTime',
              Keyword: this.searchData.OutTime
                ? this.searchData.OutTime.join(',')
                : '',
            },
          ],
        })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.DataList = resJson.Data
            this.pagination.total = resJson.Total
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 120px);
  padding: 20px;
  padding-top: 0;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
::v-deep .el-tabs {
  height: calc(100% - 20px);
  .el-tabs__content {
    height: calc(100% - 40px);
    .el-tab-pane {
      height: 100%;
    }
  }
}
</style>
